import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CognitoService } from "src/app/core/services/cognito/cognito.service";
import { NotificationService } from "src/app/core/services/notification/notification.service";
import { RestCallService } from "src/app/core/services/rest-call/rest-call.service";
import { TranslateApplicationService } from "src/app/core/translate/translate-application-service";
import { IPrinterConfigurations } from '../Interfaces/IPrinterConfigurations';

@Injectable({
  providedIn: 'root',
})
export class PrinterConfigurationsService extends RestCallService {
  public dataToSend: IPrinterConfigurations = {
    pkprinterconfiguration: 0,
    fksite: 0,
    fkbuilding: 0,
    building: '',
    fktypelabelprinter: 0,
    typelabelname: '',
    labelpath: '',
    printerpath: '',
    labelquantity: 0,
    printernumber: 0,
    creationdate: new Date(),
    strcreationdate: '',
    fkemployeecreator: 0,
    employeecreatorname: '',
    lastupdated: new Date(),
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeeupdatername: '',
    available: false,
    username: ''
  }

  constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient,'JACSapi',toastr,notificationService,translate);
  }
  
  public GetPrinterConfigurationBySite() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));

    return this.post<IPrinterConfigurations[]>('/api/PrinterConfigurations/GetPrinterConfigurationBySite', this.dataToSend);
  }

  public CreatePrinterConfiguration(data: any) {
     if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.labelpath = data.txtlabelpath;
    this.dataToSend.printerpath = data.txtprinterpath;
    this.dataToSend.labelquantity = data.txtlabelquantity;
    this.dataToSend.printernumber = data.txtprinternumber;
    this.dataToSend.fkbuilding = data.cbfkbuilding;
    this.dataToSend.fktypelabelprinter = data.cbfktypelabelprinter;
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));

    return this.post<boolean>('/api/PrinterConfigurations/CreatePrinterConfiguration', this.dataToSend);
  }

  public ChangeStatusPrinterConfiguration(data: any) {
     if (!this.cognitoService.IsAuhtenticated())
       this.cognitoService.LogOut();
    this.dataToSend.pkprinterconfiguration = data.pkprinterconfiguration;
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));

    return this.put<boolean>('/api/PrinterConfigurations/ChangeStatusPrinterConfiguration', this.dataToSend);
  }

   public UpdatePrinterConfiguration(data: any) {
     if (!this.cognitoService.IsAuhtenticated())
       this.cognitoService.LogOut();
    this.dataToSend.pkprinterconfiguration = data.pkprinterconfiguration;
    this.dataToSend.labelpath = data.txtlabelpath;
    this.dataToSend.printerpath = data.txtprinterpath;
    this.dataToSend.labelquantity = data.txtlabelquantity;
    this.dataToSend.printernumber = data.txtprinternumber;
    this.dataToSend.fkbuilding = data.cbfkbuilding;
    this.dataToSend.fktypelabelprinter = data.cbfktypelabelprinter;
    this.dataToSend.fkemployeecreator = data.fkemployeecreator;
    this.dataToSend.available = data.available;
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));

    return this.put<boolean>('/api/PrinterConfigurations/UpdatePrinterConfiguration', this.dataToSend);
  }
}